import React, { useState, useMemo, useCallback } from 'react';
import {
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OtherRequirementInfo from './OtherRequirementInfo';

interface Step5CompanyUnitProps extends StepProps {
  companyUnits: { id: number; name: string }[];
  otherRequirementInfo: any;
  setOtherRequirementInfo: (any) => void;
}

const Step5CompanyUnit: React.FC<Step5CompanyUnitProps> = ({
  currentStepName,
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  companyUnits,
  otherRequirementInfo,
  setOtherRequirementInfo,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const [selectedUnits, setSelectedUnits] = useState<{ id: number; name: string }[]>(
    (currentData as any).unitIds || []
  );

  const selectOptions = useMemo(
    () => companyUnits.map((u) => ({ value: u.id, label: u.name })),
    [companyUnits],
  );

  const handleUnitChange = useCallback(
    (val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
      if (Array.isArray(val)) {
        const units = val.map((v) => companyUnits.find((u) => u.id === v.value)).filter(Boolean) as { id: number; name: string }[];
        setSelectedUnits(units);
      } else if (val) {
        const unit = companyUnits.find((u) => u.id === val.value);
        setSelectedUnits(unit ? [unit] : []);
      } else {
        setSelectedUnits([]);
      }
    },
    [companyUnits],
  );

  const handleNext = () => {
    if (selectedUnits.length > 0) {
      onNext({
        unitIds: selectedUnits,
        _unitNames: selectedUnits.map((u) => u.name).join(', '),
      } as any);
    }
  };

  const isValid = selectedUnits.length > 0;

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <Box
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            {/* Company Unit Field */}
          <Box style={{ marginBottom: theme.spacing(3) }}>
            {/* <Typography
              variant="body2"
              style={{
                fontWeight: 600,
                marginBottom: '4px',
                fontSize: '14px',
              }}
            >
              {formatMessage({
                id: 'form.selectCompanyUnits',
                defaultMessage: 'Company Unit',
              })}
              {' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography> */}
            <SelectField
              name="companyUnit"
              placeholder={formatMessage({
                id: 'form.selectCompanyUnits',
                defaultMessage: 'Company Unit',
              })}
              options={selectOptions}
              errorTexts={[]}
              isMulti={true}
              initialState={
                selectedUnits.length > 0
                  ? selectedUnits.map((u) => ({ value: u.id, label: u.name }))
                  : undefined
              }
              onChange={handleUnitChange}
              menuPlacement="auto"
              maxMenuHeight={210}
            />
            </Box>
          </Box>
        </Box>

        <OtherRequirementInfo otherRequirementStepInfo={otherRequirementInfo} currentStepName={currentStepName} onUpdate={setOtherRequirementInfo} />
      </Box>

      <StepButtonBar
        onCancel={onCancel}
        onBack={onBack}
        onNext={handleNext}
        nextLabel="form.next"
        nextDisabled={!isValid}
        formatMessage={formatMessage}
        showBack={true}
      />
    </Box>
  );
};

export default Step5CompanyUnit;
